import { Button } from '@/components/UI/Common/Admin/Button';
import { LoadingSpinner } from '@/components/UI/Common/Admin/LoadingSpinner';
import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { Pagination } from '@/components/UI/Pagination/Pagination';
import Table from '@/components/UI/Table/Table';
import { ROUTES } from '@/config/routes';
import { useResourceList } from '@/hooks/useResourceList';
import { ChatGroup } from '@/types/chats';
import { TableColumn } from '@/types/table';
import { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Filters } from '../components/Filters';

export const ChatsGroupsPage = () => {
  const {
    data: groups,
    isLoading,
    reset,
    handleFilterChange,
    handleSortChange,
    handlePageChange,
    handleLimitChange,
    filter,
    page,
    sortOrder,
    totalPages,
    totalItems,
    limit,
    sortBy,
  } = useResourceList('chat-groups');
  const navigate = useNavigate();

  const columns: TableColumn<ChatGroup>[] = useMemo(
    () => [
      {
        key: 'id',
        title: 'ID',
        sortable: true,
        sortBy,
        sortOrder,
        onColumnHeaderClick: handleSortChange,
      },
      {
        key: 'title',
        title: 'Название',
        sortable: true,
        sortBy,
        sortOrder,
        onColumnHeaderClick: handleSortChange,
      },
      {
        key: 'systemName',
        title: 'Системное имя',
        sortable: true,
        sortBy,
        sortOrder,
        onColumnHeaderClick: handleSortChange,
      },
      {
        key: 'sort',
        title: 'Порядок',
        sortable: true,
        sortBy,
        sortOrder,
        onColumnHeaderClick: handleSortChange,
      },
      {
        key: 'createdAt',
        title: 'Создана',
        sortable: true,
        sortBy,
        sortOrder,
        onColumnHeaderClick: handleSortChange,
        render: (val: unknown) =>
          new Date(val as string).toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
      },
      {
        key: 'updatedAt',
        title: 'Обновлена',
        sortable: true,
        sortBy,
        sortOrder,
        onColumnHeaderClick: handleSortChange,
        render: (val: unknown) =>
          new Date(val as string).toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
      },
    ],
    [sortBy, sortOrder],
  );

  if (isLoading || !groups) {
    return <LoadingSpinner className="h-full" text="Загрузка..." />;
  }

  return (
    <PageLayout
      title="Группы чатов"
      actions={
        <Link to={ROUTES.ADMIN.CREATE('chat-groups')}>
          <Button size="md" variant="success">
            Создать
          </Button>
        </Link>
      }
    >
      <Filters value={filter} onChange={handleFilterChange} onReset={reset} />

      <div className="overflow-x-auto">
        <Table
          data={groups.data}
          columns={columns}
          emptyMessage="Группы чатов не найдены"
          onRowClick={(row) => navigate(ROUTES.ADMIN.EDIT('chat-groups', row.id))}
        />
      </div>

      <Pagination
        className="mt-10"
        onItemsPerPageChange={handleLimitChange}
        currentPage={page}
        totalItems={totalItems}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        itemsPerPage={limit}
      />
    </PageLayout>
  );
};
